import { render, staticRenderFns } from "./FundPublicity.vue?vue&type=template&id=54215d1a&scoped=true&"
import script from "./FundPublicity.vue?vue&type=script&lang=js&"
export * from "./FundPublicity.vue?vue&type=script&lang=js&"
import style0 from "./FundPublicity.vue?vue&type=style&index=0&id=54215d1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54215d1a",
  null
  
)

export default component.exports